import axios from "axios";
import { SetPosts } from "../redux/postSlice";

const API_URL = "https://social-sync-server.onrender.com/";
export const API = axios.create({
  baseURL: API_URL,
  responseType: "json",
});

export const apiRequest = async ({ url, token, data, method }) => {
  try {
    const result = await API.request({
      url: url,
      method: method || "GET",
      data: data,
      headers: {
        "content-type": "application/json",
        Authorization: token ? `Bearer ${token}` : "",
      },
    });

    // console.log("API Response:", result);

    return result?.data;
  } catch (error) {
    const err = error.response.data;
    console.error("API Request Error:", err);
    return {
      status: err.success,
      message: err.message,
    };
  }
};

export const handleFileUpload = async (uploadFile) => {
  try {
    const formData = new FormData();
    formData.append("file", uploadFile);
    formData.append("upload_preset", "Social-Media");

    const response = await axios.post(
      `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUDINARY_ID}/image/upload/`,
      formData
    );

    console.log("Cloudinary API Response:", response);

    if (response.status === 200) {
      return response.data.secure_url;
    } else {
      console.error("Cloudinary API request failed");
    }
  } catch (error) {
    console.error("Error uploading file to Cloudinary", error);
  }
};

export const fetchPosts = async (token, dispatch, uri, data) => {
  try {
    // console.log("Fetch Posts Token:", token);

    const res = await apiRequest({
      url: uri || "/posts",
      token: token,
      method: "POST",
      data: data || {},
    });

    // console.log("Fetch Posts Response:", res);

    dispatch(SetPosts(res?.data));
    return;
  } catch (error) {
    console.error("Fetch Posts Error:", error);
  }
};

export const likePost = async ({ uri, token }) => {
  try {
    const res = await apiRequest({
      url: uri,
      token: token,
      method: "POST",
    });
    return res;
  } catch (error) {
    console.log(error);
  }
};

export const deletePost = async (id, token) => {
  try {
    const res = await apiRequest({
      url: "/posts/" + id,
      token: token,
      method: "DELETE",
    });
    return;
  } catch (error) {
    console.log(error);
  }
};

export const getUserInfo = async (token, id) => {
  try {
    const uri = id === undefined ? "/users/get-user" : `users/get-user/${id}`;
    const res = await apiRequest({
      url: uri,
      token: token,
      method: "POST",
    });

    // Check for authentication failure
    if (res.status === 401) {
      localStorage.removeItem("user");
      window.alert("User session expired. Login again.");
      window.location.replace("/login");
      return null;
    }

    return res?.user;
  } catch (error) {
    console.error("Error fetching user info", error);
    return null;
  }
};

export const sendFriendRequest = async (token, id) => {
  try {
    console.log("Request Data:", { requestTo: id });
    const response = await apiRequest({
      url: "/users/friend-request",
      token: token,
      method: "POST",
      data: { requestTo: id },
    });

    if (response && response.success) {
      console.log("Friend request sent successfully");
      // You might want to do something with the response, if needed
    } else {
      // Check for specific error messages and handle them
      if (response && response.message === "Friend Request already sent.") {
        console.log("Friend request already sent");
        // Handle this case (e.g., show a message to the user)
      } else {
        console.error("Friend request failed:", response.message);
        // Handle other error cases
      }
    }
  } catch (error) {
    console.error("Error sending friend request:", error);
    // Handle the error or log it as needed
  }
};

export const viewUserProfile = async (token, id) => {
  try {
    const res = await apiRequest({
      url: "/users/profile-view",
      token: token,
      method: "POST",
      data: id,
    });
    return;
  } catch (error) {
    console.log(error);
  }
};
